import React from 'react';
import './DashboardSupportFooter.css';

const DashboardSupportFooter = () => (
    <section className="dashboardSupportFooter" aria-label="Customer support">
        <h2 className="dashboardSupportFooter__title">NEED HELP?</h2>
        <p className="dashboardSupportFooter__message paragraph-3">
            If you&apos;re having trouble with your account or don&apos;t see a
            purchased program, USANA Customer Service is here to help.
        </p>
        <p className="dashboardSupportFooter__hours paragraph-3">
            <strong>Monday–Friday: 8 a.m. to 5 p.m. MST</strong>
        </p>
        <p className="dashboardSupportFooter__contact paragraph-3">
            <a href="tel:1-888-950-9595">1-888-950-9595</a>
            {' or '}
            <a href="mailto:customerservice@usanainc.com">
                customerservice@usanainc.com
            </a>
        </p>
    </section>
);

export default DashboardSupportFooter;
